import { Logo } from "./Logo";

export function FullPageLoader() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-background bg-depth">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-pulse">
          <Logo className="size-12" />
        </div>
        <div className="h-2 w-32 overflow-hidden rounded-full bg-muted">
          <div
            className="h-full w-1/2 animate-[loading_1.2s_ease-in-out_infinite] rounded-full"
            style={{ background: "#18F3CB" }}
          />
        </div>
      </div>
      <style>{`@keyframes loading { 0% { transform: translateX(-100%); } 100% { transform: translateX(200%); } }`}</style>
    </div>
  );
}